package com.daytimegaming.ourdailyfinances.presentation.home

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalFlexBoxApi
import androidx.compose.foundation.layout.FlexAlignItems
import androidx.compose.foundation.layout.FlexBox
import androidx.compose.foundation.layout.FlexWrap
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.DragHandle
import androidx.compose.material.icons.filled.Group
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material.icons.outlined.AddLink
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.PreviewLightDark
import androidx.compose.ui.tooling.preview.PreviewParameter
import androidx.compose.ui.tooling.preview.PreviewScreenSizes
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.daytimegaming.ourdailyfinances.domain.model.Budget
import com.daytimegaming.ourdailyfinances.domain.model.DashboardDetail
import com.daytimegaming.ourdailyfinances.domain.model.Transaction
import com.daytimegaming.ourdailyfinances.getPlatform
import com.daytimegaming.ourdailyfinances.presentation.components.AdaptiveWindowLayout
import com.daytimegaming.ourdailyfinances.presentation.components.BalanceTimeframe
import com.daytimegaming.ourdailyfinances.presentation.components.DashboardBalanceOverTimeCard
import com.daytimegaming.ourdailyfinances.presentation.components.IncomeVsExpensesChart
import com.daytimegaming.ourdailyfinances.presentation.components.IncomeVsExpensesLegend
import com.daytimegaming.ourdailyfinances.presentation.preview.DashboardsPreviewParameterProvider
import com.daytimegaming.ourdailyfinances.presentation.theme.AppTheme
import com.daytimegaming.ourdailyfinances.presentation.theme.GlassCard
import com.daytimegaming.ourdailyfinances.presentation.util.CATEGORIES
import com.daytimegaming.ourdailyfinances.presentation.util.formatAmount
import com.daytimegaming.ourdailyfinances.presentation.util.formatIsoDateTime
import com.daytimegaming.ourdailyfinances.presentation.util.isExpandedWidth
import com.daytimegaming.ourdailyfinances.presentation.util.isPhoneLandscape
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.number
import kotlinx.datetime.todayIn
import org.koin.compose.viewmodel.koinViewModel
import sh.calvin.reorderable.ReorderableColumn
import sh.calvin.reorderable.ReorderableItem
import sh.calvin.reorderable.rememberReorderableLazyListState
import kotlin.math.abs
import kotlin.time.Clock

@Composable
fun DashboardsScreen(
    modifier: Modifier = Modifier,
    onDashboardClick: (String) -> Unit,
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    onViewRecentSpendingClick: () -> Unit,
    onViewRecurringTransactionsClick: () -> Unit,
    onCreateBudgetClick: () -> Unit,
    onBudgetClick: (String) -> Unit,
    onManageAccounts: () -> Unit,
    onLinkFirstAccountClick: () -> Unit = onManageAccounts,
    onViewIncomeVsExpensesClick: () -> Unit = {},
    viewModel: DashboardsViewModel = koinViewModel()
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val isRefreshing by viewModel.isRefreshing.collectAsStateWithLifecycle()
    val selectedTimeframe by viewModel.selectedTimeframe.collectAsStateWithLifecycle()

    var showNoAccountsDialog by remember { mutableStateOf(false) }
    var isReorderingDashboards by remember { mutableStateOf(false) }
    var isReorderingBudgets by remember { mutableStateOf(false) }
    var isCumulativeTrending by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        viewModel.load()
    }

    DashboardsScreenContent(
        state = state,
        isRefreshing = isRefreshing,
        onRefresh = viewModel::refresh,
        onRetry = viewModel::load,
        onDashboardClick = onDashboardClick,
        onCreateDashboardClick = onCreateDashboardClick,
        onJoinDashboardClick = onJoinDashboardClick,
        onViewRecentSpendingClick = onViewRecentSpendingClick,
        onViewRecurringTransactionsClick = onViewRecurringTransactionsClick,
        onCreateBudgetClick = onCreateBudgetClick,
        onBudgetClick = onBudgetClick,
        onManageAccounts = onManageAccounts,
        onLinkFirstAccountClick = onLinkFirstAccountClick,
        onViewIncomeVsExpensesClick = onViewIncomeVsExpensesClick,
        modifier = modifier,
        onRangeSelected = viewModel::setRange,
        onReorderDashboards = viewModel::updateDashboardOrder,
        onReorderBudgets = viewModel::updateBudgetOrder,
        showNoAccountsDialog = showNoAccountsDialog,
        onShowNoAccountsDialogChange = { showNoAccountsDialog = it },
        isReorderingDashboards = isReorderingDashboards,
        onReorderingDashboardsChange = { isReorderingDashboards = it },
        isReorderingBudgets = isReorderingBudgets,
        onReorderingBudgetsChange = { isReorderingBudgets = it },
        isCumulativeTrending = isCumulativeTrending,
        onCumulativeTrendingChange = { isCumulativeTrending = it },
        selectedTimeframe = selectedTimeframe,
        onTimeframeSelected = viewModel::setSelectedTimeframe
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DashboardsScreenContent(
    state: DashboardsScreenState,
    onDashboardClick: (String) -> Unit,
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    onViewRecentSpendingClick: () -> Unit,
    onViewRecurringTransactionsClick: () -> Unit,
    onCreateBudgetClick: () -> Unit,
    onBudgetClick: (String) -> Unit,
    onManageAccounts: () -> Unit,
    onLinkFirstAccountClick: () -> Unit = onManageAccounts,
    onViewIncomeVsExpensesClick: () -> Unit = {},
    modifier: Modifier = Modifier,
    isRefreshing: Boolean = false,
    onRefresh: () -> Unit = {},
    onRetry: () -> Unit = onRefresh,
    onRangeSelected: (SpendingRange) -> Unit = {},
    onReorderDashboards: (List<String>) -> Unit = {},
    onReorderBudgets: (List<String>) -> Unit = {},
    showNoAccountsDialog: Boolean = false,
    onShowNoAccountsDialogChange: (Boolean) -> Unit = {},
    isReorderingDashboards: Boolean = false,
    onReorderingDashboardsChange: (Boolean) -> Unit = {},
    isReorderingBudgets: Boolean = false,
    onReorderingBudgetsChange: (Boolean) -> Unit = {},
    isCumulativeTrending: Boolean = true,
    onCumulativeTrendingChange: (Boolean) -> Unit = {},
    selectedTimeframe: BalanceTimeframe? = null,
    onTimeframeSelected: ((BalanceTimeframe) -> Unit)? = null
) {
    val snackbarHostState = remember { SnackbarHostState() }
    var hasShownSnackbar by rememberSaveable { mutableStateOf(false) }

    if (state is DashboardsScreenState.Loaded) {
        val needsAttention = state.dashboards.any { d -> d.accounts.any { it.loginRequired || it.updateRequired } }
        LaunchedEffect(needsAttention) {
            if (needsAttention && !hasShownSnackbar) {
                hasShownSnackbar = true
                val result = snackbarHostState.showSnackbar(
                    message = "One or more of our accounts require your attention...",
                    actionLabel = "Manage Accounts",
                    duration = SnackbarDuration.Long
                )
                if (result == SnackbarResult.ActionPerformed) {
                    onManageAccounts()
                }
            }
        }
    }

    if (showNoAccountsDialog) {
        AlertDialog(
            onDismissRequest = { onShowNoAccountsDialogChange(false) },
            title = { Text("Link Account Required") },
            text = { Text("Please first link an account to your profile before creating a new dashboard.") },
            confirmButton = {
                TextButton(onClick = { onShowNoAccountsDialogChange(false) }) {
                    Text("OK")
                }
            }
        )
    }

    Scaffold(
        modifier = modifier,
        snackbarHost = { SnackbarHost(hostState = snackbarHostState) },

    ) { contentPadding ->
        PullToRefreshBox(
            isRefreshing = isRefreshing,
            onRefresh = onRefresh,
            modifier = Modifier
                .fillMaxSize()
                .padding(contentPadding)
        ) {
            when (state) {
                is DashboardsScreenState.Loading -> {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        CircularProgressIndicator()
                    }
                }
                is DashboardsScreenState.Error -> {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .padding(16.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.spacedBy(16.dp)
                        ) {
                            Text(
                                text = state.message,
                                color = MaterialTheme.colorScheme.error,
                                style = MaterialTheme.typography.bodyMedium,
                                textAlign = TextAlign.Center
                            )
                            Button(onClick = onRetry) {
                                Text("Retry")
                            }
                        }
                    }
                }
                is DashboardsScreenState.Loaded -> {
                    if (state.dashboards.isEmpty()) {
                        if (!state.hasLinkedAccounts) {
                            NoAccountsOnboardingContent(
                                onLinkFirstAccountClick = onLinkFirstAccountClick,
                                onJoinDashboardClick = onJoinDashboardClick
                            )
                        } else {
                            NoDashboardsOnboardingContent(
                                onCreateDashboardClick = onCreateDashboardClick,
                                onJoinDashboardClick = onJoinDashboardClick
                            )
                        }
                    } else {
                        val onCreateDashboardClickAction = {
                            if (state.hasLinkedAccounts) {
                                onCreateDashboardClick()
                            } else {
                                onShowNoAccountsDialogChange(true)
                            }
                        }

                        AdaptiveWindowLayout(
                            compactContent = {
                                CompactContent(
                                    state = state,
                                    onDashboardClick = onDashboardClick,
                                    onCreateDashboardClick = onCreateDashboardClickAction,
                                    onJoinDashboardClick = onJoinDashboardClick,
                                    onViewRecentSpendingClick = onViewRecentSpendingClick,
                                    onViewRecurringTransactionsClick = onViewRecurringTransactionsClick,
                                    onCreateBudgetClick = onCreateBudgetClick,
                                    onBudgetClick = onBudgetClick,
                                    onRangeSelected = onRangeSelected,
                                    onConfigClick = { onReorderingDashboardsChange(!isReorderingDashboards) },
                                    onBudgetConfigClick = { onReorderingBudgetsChange(!isReorderingBudgets) },
                                    isReorderingBudgets = isReorderingBudgets,
                                    onReorderBudgets = onReorderBudgets,
                                    isReorderingDashboards = isReorderingDashboards,
                                    onReorderDashboards = onReorderDashboards,
                                    isCumulativeTrending = isCumulativeTrending,
                                    onCumulativeTrendingChange = onCumulativeTrendingChange,
                                    selectedTimeframe = selectedTimeframe,
                                    onTimeframeSelected = onTimeframeSelected,
                                    onViewIncomeVsExpensesClick = onViewIncomeVsExpensesClick
                                )
                            },
                            mediumContent = {
                                MediumContent(
                                    state = state,
                                    onDashboardClick = onDashboardClick,
                                    onCreateDashboardClick = onCreateDashboardClickAction,
                                    onJoinDashboardClick = onJoinDashboardClick,
                                    onViewRecentSpendingClick = onViewRecentSpendingClick,
                                    onViewRecurringTransactionsClick = onViewRecurringTransactionsClick,
                                    onCreateBudgetClick = onCreateBudgetClick,
                                    onBudgetClick = onBudgetClick,
                                    onRangeSelected = onRangeSelected,
                                    onConfigClick = { onReorderingDashboardsChange(!isReorderingDashboards) },
                                    onBudgetConfigClick = { onReorderingBudgetsChange(!isReorderingBudgets) },
                                    isReorderingBudgets = isReorderingBudgets,
                                    onReorderBudgets = onReorderBudgets,
                                    isReorderingDashboards = isReorderingDashboards,
                                    onReorderDashboards = onReorderDashboards,
                                    isCumulativeTrending = isCumulativeTrending,
                                    onCumulativeTrendingChange = onCumulativeTrendingChange,
                                    selectedTimeframe = selectedTimeframe,
                                    onTimeframeSelected = onTimeframeSelected,
                                    onViewIncomeVsExpensesClick = onViewIncomeVsExpensesClick
                                )
                            },
                            expandedContent = {
                                ExpandedContent(
                                    state = state,
                                    onDashboardClick = onDashboardClick,
                                    onCreateDashboardClick = onCreateDashboardClickAction,
                                    onJoinDashboardClick = onJoinDashboardClick,
                                    onViewRecentSpendingClick = onViewRecentSpendingClick,
                                    onViewRecurringTransactionsClick = onViewRecurringTransactionsClick,
                                    onCreateBudgetClick = onCreateBudgetClick,
                                    onBudgetClick = onBudgetClick,
                                    onRangeSelected = onRangeSelected,
                                    onConfigClick = { onReorderingDashboardsChange(!isReorderingDashboards) },
                                    onBudgetConfigClick = { onReorderingBudgetsChange(!isReorderingBudgets) },
                                    isReorderingBudgets = isReorderingBudgets,
                                    onReorderBudgets = onReorderBudgets,
                                    isReorderingDashboards = isReorderingDashboards,
                                    onReorderDashboards = onReorderDashboards,
                                    isCumulativeTrending = isCumulativeTrending,
                                    onCumulativeTrendingChange = onCumulativeTrendingChange,
                                    selectedTimeframe = selectedTimeframe,
                                    onTimeframeSelected = onTimeframeSelected,
                                    onViewIncomeVsExpensesClick = onViewIncomeVsExpensesClick
                                )
                            }
                        )
                }
            }
        }
    }
}
}

@Composable
private fun CompactContent(
    state: DashboardsScreenState.Loaded,
    onDashboardClick: (String) -> Unit,
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    onViewRecentSpendingClick: () -> Unit,
    onViewRecurringTransactionsClick: () -> Unit,
    onCreateBudgetClick: () -> Unit,
    onBudgetClick: (String) -> Unit,
    onRangeSelected: (SpendingRange) -> Unit = {},
    onConfigClick: () -> Unit,
    onBudgetConfigClick: () -> Unit,
    isReorderingBudgets: Boolean,
    onReorderBudgets: (List<String>) -> Unit,
    isReorderingDashboards: Boolean,
    onReorderDashboards: (List<String>) -> Unit,
    isCumulativeTrending: Boolean,
    onCumulativeTrendingChange: (Boolean) -> Unit,
    selectedTimeframe: BalanceTimeframe? = null,
    onTimeframeSelected: ((BalanceTimeframe) -> Unit)? = null,
    onViewIncomeVsExpensesClick: () -> Unit = {}
) {
    val lazyListState = rememberLazyListState()
    val dashboardsReorderState = rememberReorderableLazyListState(lazyListState) { from, to ->
        state.dashboards.reordered(from.key, to.key, DashboardDetail::dashboardId)?.let { updated ->
            onReorderDashboards(updated.map { it.dashboardId })
        }
    }

    val budgetsReorderState = rememberReorderableLazyListState(lazyListState) { from, to ->
        state.budgets.reordered(from.key, to.key, Budget::budgetId)?.let { updated ->
            onReorderBudgets(updated.map { it.budgetId })
        }
    }

    LazyColumn(
        state = lazyListState,
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.spacedBy(16.dp),
        contentPadding = PaddingValues(bottom = 32.dp)
    ) {
        item(key = "wealth_balance") {
            TotalWealthBalanceCard(
                totalBalance = state.totalBalance,
                lastSync = state.lastSync,
            )
        }

        item(key = "balance_history") {
            DashboardBalanceOverTimeCard(
                accounts = state.combinedAccounts,
                transactions = state.transactions,
                holdings = state.combinedHoldings,
                securityPerformance = state.securityPerformance,
                realEstateHoldings = state.combinedRealEstateHoldings,
                selectedTimeframe = selectedTimeframe ?: state.selectedTimeframe,
                onTimeframeSelected = onTimeframeSelected,
                isSecurityPerformanceLoading = state.isSecurityPerformanceLoading,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp)
            )
        }

        item(key = "dashboards_header") {
            ActiveDashboardsHeader(
                onCreateDashboardClick = onCreateDashboardClick,
                onJoinDashboardClick = onJoinDashboardClick,
                showConfigAction = state.dashboards.isNotEmpty(),
                isReordering = isReorderingDashboards,
                onConfigClick = onConfigClick
            )
        }

        if (state.dashboards.isEmpty()) {
            item(key = "no_dashboards") {
                NoDashboardsCard()
            }
        } else {
            items(state.dashboards, key = { it.dashboardId }) { dashboard ->
                ReorderableItem(state = dashboardsReorderState, key = dashboard.dashboardId) { isDragging ->
                    val elevation by animateDpAsState(if (isDragging) 8.dp else 0.dp)
                    Surface(
                        shadowElevation = elevation,
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        DashboardDetailCard(
                            dashboard = dashboard,
                            onDashboardClick = onDashboardClick,
                            dragHandleModifier = if (isReorderingDashboards) Modifier.draggableHandle() else null
                        )
                    }
                }
            }
        }

        item(key = "budgets_header") {
            BudgetsHeader(
                onCreateBudgetClick = onCreateBudgetClick,
                showConfigAction = state.budgets.isNotEmpty(),
                isReordering = isReorderingBudgets,
                onConfigClick = onBudgetConfigClick
            )
        }
        if (state.budgets.isEmpty()) {
            item(key = "no_budgets") {
                NoBudgetsCard()
            }
        } else {
            items(state.budgets, key = { it.budgetId }) { budget ->
                ReorderableItem(state = budgetsReorderState, key = budget.budgetId) { isDragging ->
                    val elevation by animateDpAsState(if (isDragging) 8.dp else 0.dp)
                    Surface(
                        shadowElevation = elevation,
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        BudgetDetailCard(
                            budget = budget,
                            progress = state.budgetProgress[budget.budgetId],
                            onClick = { onBudgetClick(budget.budgetId) },
                            dragHandleModifier = if (isReorderingBudgets) Modifier.draggableHandle() else null
                        )
                    }
                }
            }
        }

        item(key = "recent_spending") {
            RecentSpendingSection(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 16.dp),
                state = state,
                onRangeSelected = onRangeSelected,
                onViewRecentSpendingClick = onViewRecentSpendingClick
            )
        }

        item(key = "recurring_subscriptions") {
            RecurringSubscriptionsSection(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 16.dp),
                state = state,
                onViewRecurringTransactionsClick = onViewRecurringTransactionsClick
            )
        }

        item(key = "trending_spending") {
            TrendingSpendingSection(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 16.dp),
                state = state,
                isCumulative = isCumulativeTrending,
                onCumulativeChange = onCumulativeTrendingChange
            )
        }

        item(key = "income_vs_expenses") {
            IncomeVsExpensesSection(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 16.dp),
                state = state,
                onViewDetailsClick = onViewIncomeVsExpensesClick
            )
        }
    }
}

@OptIn(ExperimentalFlexBoxApi::class)
@Composable
private fun MediumContent(
    state: DashboardsScreenState.Loaded,
    onDashboardClick: (String) -> Unit,
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    onViewRecentSpendingClick: () -> Unit,
    onViewRecurringTransactionsClick: () -> Unit,
    onCreateBudgetClick: () -> Unit,
    onBudgetClick: (String) -> Unit,
    onRangeSelected: (SpendingRange) -> Unit = {},
    onConfigClick: () -> Unit,
    onBudgetConfigClick: () -> Unit,
    isReorderingBudgets: Boolean,
    onReorderBudgets: (List<String>) -> Unit,
    isReorderingDashboards: Boolean,
    onReorderDashboards: (List<String>) -> Unit,
    isCumulativeTrending: Boolean,
    onCumulativeTrendingChange: (Boolean) -> Unit,
    selectedTimeframe: BalanceTimeframe? = null,
    onTimeframeSelected: ((BalanceTimeframe) -> Unit)? = null,
    onViewIncomeVsExpensesClick: () -> Unit = {}
) {
    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.spacedBy(16.dp),
        contentPadding = PaddingValues(top = 0.dp, start = 48.dp, end = 48.dp, bottom = 32.dp)
    ) {
        item {
            TotalWealthBalanceCard(
                totalBalance = state.totalBalance,
                lastSync = state.lastSync,
            )
        }

        item {
            DashboardBalanceOverTimeCard(
                accounts = state.combinedAccounts,
                transactions = state.transactions,
                holdings = state.combinedHoldings,
                securityPerformance = state.securityPerformance,
                realEstateHoldings = state.combinedRealEstateHoldings,
                selectedTimeframe = selectedTimeframe ?: state.selectedTimeframe,
                onTimeframeSelected = onTimeframeSelected,
                isSecurityPerformanceLoading = state.isSecurityPerformanceLoading,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp)
            )
        }

        item {
            ActiveDashboardsSection(
                onCreateDashboardClick,
                onJoinDashboardClick,
                state,
                isReorderingDashboards,
                onConfigClick,
                onReorderDashboards,
                onDashboardClick
            )
        }

        item {
            BudgetsSection(
                onCreateBudgetClick,
                state,
                isReorderingBudgets,
                onBudgetConfigClick,
                onReorderBudgets,
                onBudgetClick
            )
        }

        item {
            RecentSpendingSection(
                state = state,
                onRangeSelected = onRangeSelected,
                onViewRecentSpendingClick = onViewRecentSpendingClick
            )
        }

        item {
            RecurringSubscriptionsSection(
                state = state,
                onViewRecurringTransactionsClick = onViewRecurringTransactionsClick
            )
        }

        item {
            TrendingSpendingSection(
                state = state,
                isCumulative = isCumulativeTrending,
                onCumulativeChange = onCumulativeTrendingChange
            )
        }

        item {
            IncomeVsExpensesSection(
                state = state,
                onViewDetailsClick = onViewIncomeVsExpensesClick
            )
        }
    }
}

@OptIn(ExperimentalFlexBoxApi::class)
@Composable
private fun ExpandedContent(
    state: DashboardsScreenState.Loaded,
    onDashboardClick: (String) -> Unit,
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    onViewRecentSpendingClick: () -> Unit,
    onViewRecurringTransactionsClick: () -> Unit,
    onCreateBudgetClick: () -> Unit,
    onBudgetClick: (String) -> Unit,
    onRangeSelected: (SpendingRange) -> Unit = {},
    onConfigClick: () -> Unit,
    onBudgetConfigClick: () -> Unit,
    isReorderingBudgets: Boolean,
    onReorderBudgets: (List<String>) -> Unit,
    isReorderingDashboards: Boolean,
    onReorderDashboards: (List<String>) -> Unit,
    isCumulativeTrending: Boolean,
    onCumulativeTrendingChange: (Boolean) -> Unit,
    selectedTimeframe: BalanceTimeframe? = null,
    onTimeframeSelected: ((BalanceTimeframe) -> Unit)? = null,
    onViewIncomeVsExpensesClick: () -> Unit = {}
) {
    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        LazyColumn(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.spacedBy(16.dp),
            contentPadding = PaddingValues(top = 0.dp, start = 48.dp, end = 48.dp, bottom = 32.dp)
        ) {
            item {
                TotalWealthBalanceCard(
                    totalBalance = state.totalBalance,
                    lastSync = state.lastSync,
                )
            }

            item {
                DashboardBalanceOverTimeCard(
                    accounts = state.combinedAccounts,
                    transactions = state.transactions,
                    holdings = state.combinedHoldings,
                    securityPerformance = state.securityPerformance,
                    realEstateHoldings = state.combinedRealEstateHoldings,
                    selectedTimeframe = selectedTimeframe ?: state.selectedTimeframe,
                    onTimeframeSelected = onTimeframeSelected,
                    isSecurityPerformanceLoading = state.isSecurityPerformanceLoading,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp)
                )
            }

            item {
                val isDesktop = getPlatform().name.startsWith("Java") || getPlatform().name == "Web Browser"
                val useThreeColumns = isDesktop && maxWidth > 1280.dp

                if (useThreeColumns) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(24.dp),
                    ) {
                        Column(
                            modifier = Modifier.weight(1.0f),
                            verticalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            ActiveDashboardsSection(
                                onCreateDashboardClick,
                                onJoinDashboardClick,
                                state,
                                isReorderingDashboards,
                                onConfigClick,
                                onReorderDashboards,
                                onDashboardClick
                            )

                            BudgetsSection(
                                onCreateBudgetClick,
                                state,
                                isReorderingBudgets,
                                onBudgetConfigClick,
                                onReorderBudgets,
                                onBudgetClick
                            )
                        }

                        Column(
                            modifier = Modifier.weight(1.0f),
                            verticalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            RecentSpendingSection(
                                state = state,
                                onRangeSelected = onRangeSelected,
                                onViewRecentSpendingClick = onViewRecentSpendingClick
                            )

                            TrendingSpendingSection(
                                state = state,
                                isCumulative = isCumulativeTrending,
                                onCumulativeChange = onCumulativeTrendingChange
                            )
                        }

                        Column(
                            modifier = Modifier.weight(1.0f),
                            verticalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            RecurringSubscriptionsSection(
                                state = state,
                                onViewRecurringTransactionsClick = onViewRecurringTransactionsClick
                            )

                            IncomeVsExpensesSection(
                                state = state,
                                onViewDetailsClick = onViewIncomeVsExpensesClick
                            )
                        }
                    }
                } else {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(24.dp),
                    ) {
                        Column(
                            modifier = Modifier.weight(1.0f),
                            verticalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            ActiveDashboardsSection(
                                onCreateDashboardClick,
                                onJoinDashboardClick,
                                state,
                                isReorderingDashboards,
                                onConfigClick,
                                onReorderDashboards,
                                onDashboardClick
                            )

                            BudgetsSection(
                                onCreateBudgetClick,
                                state,
                                isReorderingBudgets,
                                onBudgetConfigClick,
                                onReorderBudgets,
                                onBudgetClick
                            )
                        }

                        Column(
                            modifier = Modifier.weight(1.0f),
                            verticalArrangement = Arrangement.spacedBy(16.dp),
                        ) {
                            RecentSpendingSection(
                                state = state,
                                onRangeSelected = onRangeSelected,
                                onViewRecentSpendingClick = onViewRecentSpendingClick
                            )

                            RecurringSubscriptionsSection(
                                state = state,
                                onViewRecurringTransactionsClick = onViewRecurringTransactionsClick
                            )

                            TrendingSpendingSection(
                                state = state,
                                isCumulative = isCumulativeTrending,
                                onCumulativeChange = onCumulativeTrendingChange
                            )

                            IncomeVsExpensesSection(
                                state = state,
                                onViewDetailsClick = onViewIncomeVsExpensesClick
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun BudgetsSection(
    onCreateBudgetClick: () -> Unit,
    state: DashboardsScreenState.Loaded,
    isReorderingBudgets: Boolean,
    onBudgetConfigClick: () -> Unit,
    onReorderBudgets: (List<String>) -> Unit,
    onBudgetClick: (String) -> Unit
) {
    BudgetsHeader(
        onCreateBudgetClick = onCreateBudgetClick,
        showConfigAction = state.budgets.isNotEmpty(),
        isReordering = isReorderingBudgets,
        onConfigClick = onBudgetConfigClick
    )

    if (state.budgets.isEmpty()) {
        NoBudgetsCard()
    } else {
        BudgetReorderableColumn(
            budgets = state.budgets,
            budgetProgress = state.budgetProgress,
            isReorderingBudgets = isReorderingBudgets,
            onReorderBudgets = onReorderBudgets,
            onBudgetClick = onBudgetClick,
        )
    }
}

@Composable
private fun ActiveDashboardsSection(
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    state: DashboardsScreenState.Loaded,
    isReorderingDashboards: Boolean,
    onConfigClick: () -> Unit,
    onReorderDashboards: (List<String>) -> Unit,
    onDashboardClick: (String) -> Unit
) {
    ActiveDashboardsHeader(
        onCreateDashboardClick = onCreateDashboardClick,
        onJoinDashboardClick = onJoinDashboardClick,
        showConfigAction = state.dashboards.isNotEmpty(),
        isReordering = isReorderingDashboards,
        onConfigClick = onConfigClick
    )

    if (state.dashboards.isEmpty()) {
        NoDashboardsCard()
    } else {
        DashboardReorderableColumn(
            dashboards = state.dashboards,
            isReorderingDashboards = isReorderingDashboards,
            onReorderDashboards = onReorderDashboards,
            onDashboardClick = onDashboardClick,
        )
    }
}

@Composable
private fun DashboardReorderableColumn(
    dashboards: List<DashboardDetail>,
    isReorderingDashboards: Boolean,
    onReorderDashboards: (List<String>) -> Unit,
    onDashboardClick: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    ReorderableColumn(
        modifier = modifier,
        list = dashboards,
        verticalArrangement = Arrangement.spacedBy(16.dp),
        onSettle = { fromIndex, toIndex ->
            dashboards.reordered(fromIndex, toIndex, DashboardDetail::dashboardId)?.let { updated ->
                onReorderDashboards(updated.map { it.dashboardId })
            }
        },
        content = { index, dashboard, isDragging ->
            key(dashboard.dashboardId) {
                ReorderableItem {
                    val elevation by animateDpAsState(if (isDragging) 8.dp else 0.dp)
                    Surface(
                        shadowElevation = elevation,
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        DashboardDetailCard(
                            dashboard = dashboard,
                            onDashboardClick = onDashboardClick,
                            dragHandleModifier = if (isReorderingDashboards) Modifier.draggableHandle() else null
                        )
                    }
                }
            }
        }
    )
}

@Composable
private fun BudgetReorderableColumn(
    budgets: List<Budget>,
    budgetProgress: Map<String, BudgetProgress>,
    isReorderingBudgets: Boolean,
    onReorderBudgets: (List<String>) -> Unit,
    onBudgetClick: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    ReorderableColumn(
        modifier = modifier,
        list = budgets,
        verticalArrangement = Arrangement.spacedBy(16.dp),
        onSettle = { fromIndex, toIndex ->
            budgets.reordered(fromIndex, toIndex, Budget::budgetId)?.let { updated ->
                onReorderBudgets(updated.map { it.budgetId })
            }
        },
        content = { index, budget, isDragging ->
            key(budget.budgetId) {
                ReorderableItem {
                    val elevation by animateDpAsState(if (isDragging) 8.dp else 0.dp)
                    Surface(
                        shadowElevation = elevation,
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        BudgetDetailCard(
                            budget = budget,
                            progress = budgetProgress[budget.budgetId],
                            onClick = { onBudgetClick(budget.budgetId) },
                            dragHandleModifier = if (isReorderingBudgets) Modifier.draggableHandle() else null
                        )
                    }
                }
            }
        }
    )
}

@Composable
private fun NoDashboardsCard() {
    Box(modifier = Modifier.padding(horizontal = 16.dp)) {
        GlassCard(modifier = Modifier.fillMaxWidth()) {
            Text(
                text = "No dashboards configured yet.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(16.dp)
            )
        }
    }
}

@Composable
private fun NoAccountsOnboardingContent(
    onLinkFirstAccountClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    OnboardingDualCardLayout(
        primaryCardTitle = "Welcome to Our Daily Finances",
        primaryCardBody = "You don't have any active dashboards or linked accounts yet. Link your first financial institution to start tracking your household wealth automatically.",
        primaryButtonText = "Link First Account",
        primaryButtonIcon = Icons.Outlined.AddLink,
        onPrimaryButtonClick = onLinkFirstAccountClick,
        onJoinDashboardClick = onJoinDashboardClick,
        modifier = modifier
    )
}

@Composable
private fun NoDashboardsOnboardingContent(
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    OnboardingDualCardLayout(
        primaryCardTitle = "Welcome to Our Daily Finances",
        primaryCardBody = "You don't have any active dashboards yet. Create your first dashboard to start organizing your accounts, tracking budgets, and monitoring your financial health.",
        primaryButtonText = "Create First Dashboard",
        primaryButtonIcon = Icons.Default.Add,
        onPrimaryButtonClick = onCreateDashboardClick,
        onJoinDashboardClick = onJoinDashboardClick,
        modifier = modifier
    )
}

@Composable
private fun OnboardingDualCardLayout(
    primaryCardTitle: String,
    primaryCardBody: String,
    primaryButtonText: String,
    primaryButtonIcon: ImageVector,
    onPrimaryButtonClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val adaptiveInfo = currentWindowAdaptiveInfo()
    val isHorizontal = adaptiveInfo.windowSizeClass.isPhoneLandscape() || adaptiveInfo.windowSizeClass.isExpandedWidth()
    val isWideScreen = adaptiveInfo.windowSizeClass.isExpandedWidth()

    Box(
        modifier = modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(16.dp),
        contentAlignment = Alignment.Center,
    ) {
        if (isHorizontal) {
            Row(
                modifier = Modifier
                    .widthIn(max = 900.dp)
                    .fillMaxWidth()
                    .height(IntrinsicSize.Max),
                horizontalArrangement = Arrangement.spacedBy(if (isWideScreen) 40.dp else 20.dp, Alignment.CenterHorizontally),
                verticalAlignment = Alignment.CenterVertically
            ) {
                OnboardingCard(
                    title = primaryCardTitle,
                    body = primaryCardBody,
                    buttonText = primaryButtonText,
                    buttonIcon = primaryButtonIcon,
                    onClick = onPrimaryButtonClick,
                    modifier = Modifier.weight(1f).fillMaxHeight()
                )
                OnboardingCard(
                    title = "Join Existing Dashboard",
                    body = "Have an invite code from a household member or partner? Join their dashboard to start collaborating on shared finances.",
                    buttonText = "Join Dashboard",
                    buttonIcon = Icons.Default.Group,
                    onClick = onJoinDashboardClick,
                    modifier = Modifier.weight(1f).fillMaxHeight()
                )
            }
        } else {
            Column(
                modifier = Modifier
                    .widthIn(max = 500.dp)
                    .fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(20.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                OnboardingCard(
                    title = primaryCardTitle,
                    body = primaryCardBody,
                    buttonText = primaryButtonText,
                    buttonIcon = primaryButtonIcon,
                    onClick = onPrimaryButtonClick,
                    modifier = Modifier.fillMaxWidth()
                )
                OnboardingCard(
                    title = "Join Existing Dashboard",
                    body = "Have an invite code from a household member or partner? Join their dashboard to start collaborating on shared finances.",
                    buttonText = "Join Dashboard",
                    buttonIcon = Icons.Default.Group,
                    onClick = onJoinDashboardClick,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@Composable
private fun OnboardingCard(
    title: String,
    body: String,
    buttonText: String,
    buttonIcon: ImageVector,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    GlassCard(
        modifier = modifier
    ) {
        Column(
            modifier = Modifier.fillMaxHeight(),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.headlineSmall,
                    color = MaterialTheme.colorScheme.primary,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth()
                )
                Text(
                    text = body,
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Spacer(modifier = Modifier.height(24.dp))
            Button(
                onClick = onClick,
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(12.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer,
                    contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                ),
                contentPadding = PaddingValues(vertical = 12.dp)
            ) {
                Icon(
                    imageVector = buttonIcon,
                    contentDescription = null,
                    modifier = Modifier.size(20.dp)
                )
                Spacer(modifier = Modifier.width(8.dp))
                Text(
                    text = buttonText,
                    style = MaterialTheme.typography.labelLarge,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}

@Composable
private fun BudgetsHeader(
    onCreateBudgetClick: () -> Unit,
    showConfigAction: Boolean,
    isReordering: Boolean = false,
    onConfigClick: () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = "Budgets",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface
        )
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            OutlinedButton(
                onClick = onCreateBudgetClick,
                shape = RoundedCornerShape(8.dp),
                colors = ButtonDefaults.outlinedButtonColors(
                    contentColor = MaterialTheme.colorScheme.primary
                ),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary),
                contentPadding = PaddingValues(0.dp),
                modifier = Modifier.size(36.dp)
            ) {
                Icon(
                    imageVector = Icons.Default.Add,
                    contentDescription = "Create Budget",
                )
            }
            if (showConfigAction) {
                OutlinedButton(
                    onClick = onConfigClick,
                    shape = RoundedCornerShape(8.dp),
                    colors = if (isReordering) {
                        ButtonDefaults.outlinedButtonColors(
                            containerColor = MaterialTheme.colorScheme.primary,
                            contentColor = MaterialTheme.colorScheme.onPrimary
                        )
                    } else {
                        ButtonDefaults.outlinedButtonColors(
                            contentColor = MaterialTheme.colorScheme.primary
                        )
                    },
                    border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary),
                    contentPadding = PaddingValues(0.dp),
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = if (isReordering) Icons.Default.Check else Icons.Default.Settings,
                        contentDescription = if (isReordering) "Finish Reordering Budgets" else "Configure Budget Order",
                    )
                }
            }
        }
    }
}

@Composable
private fun NoBudgetsCard() {
    Box(modifier = Modifier.padding(horizontal = 16.dp)) {
        GlassCard(modifier = Modifier.fillMaxWidth()) {
            Text(
                text = "No budgets configured yet.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(16.dp)
            )
        }
    }
}

@Composable
private fun BudgetDetailCard(
    budget: Budget,
    progress: BudgetProgress?,
    onClick: () -> Unit,
    dragHandleModifier: Modifier? = null
) {
    Box(modifier = Modifier.padding(horizontal = 16.dp)) {
        GlassCard(
            modifier = Modifier.fillMaxWidth().then(
                if (dragHandleModifier == null) Modifier.clickable { onClick() } else Modifier
            )
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier.weight(1f)
                ) {
                    Text(
                        text = budget.name,
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.onSurface
                    )

                    Spacer(modifier = Modifier.height(8.dp))
                    
                    val cleanCategories = budget.categories.map { detailed ->
                        val primary = CATEGORIES.find { it.second == detailed }?.first ?: ""
                        cleanCategoryName(primary, detailed)
                    }.joinToString(", ")
                    
                    Text(
                        text = cleanCategories,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )

                    if (progress != null) {
                        Spacer(modifier = Modifier.height(12.dp))

                        val progressValue = progress.progress.coerceIn(0f, 1f)
                        val indicatorColor = if (progress.progress > 1f) {
                            MaterialTheme.colorScheme.error
                        } else if (progress.progress > 0.8f) {
                            MaterialTheme.colorScheme.error.copy(alpha = 0.7f)
                        } else {
                            MaterialTheme.colorScheme.primary
                        }

                        LinearProgressIndicator(
                            progress = { progressValue },
                            modifier = Modifier.fillMaxWidth().height(6.dp).clip(RoundedCornerShape(3.dp)),
                            color = indicatorColor,
                            trackColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.3f),
                            drawStopIndicator = {},
                        )

                        Spacer(modifier = Modifier.height(8.dp))

                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                text = "$${progress.currentMonthSpending.formatAmount()} spent of $${budget.targetValue.formatAmount()}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.primary,
                            )

                            if (progress.changePercentage != null) {
                                val isUp = progress.changePercentage > 0.0
                                val percentText = if (isUp) {
                                    "+${progress.changePercentage.formatAmount()}%"
                                } else {
                                    "${progress.changePercentage.formatAmount()}%"
                                }
                                val changeColor = if (isUp) {
                                    MaterialTheme.colorScheme.error
                                } else {
                                    Color(0xFF00C853)
                                }
                                Text(
                                    text = "$percentText vs last mo.",
                                    style = MaterialTheme.typography.labelSmall,
                                    fontWeight = FontWeight.Bold,
                                    color = changeColor
                                )
                            } else {
                                Text(
                                    text = "No previous spending",
                                    style = MaterialTheme.typography.labelSmall,
                                    color = MaterialTheme.colorScheme.outline
                                )
                            }
                        }
                    }
                }
                
                if (dragHandleModifier != null) {
                    Spacer(modifier = Modifier.width(16.dp))
                    Icon(
                        imageVector = Icons.Default.DragHandle,
                        contentDescription = "Drag to reorder",
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = dragHandleModifier.size(24.dp)
                    )
                }
            }
        }
    }
}

private fun cleanCategoryName(primary: String, detailed: String): String {
    val cleanPrimary = primary.trim()
    val cleanDetailed = detailed.trim()
    val remaining = if (cleanPrimary.isNotEmpty() && cleanDetailed.startsWith(cleanPrimary)) {
        val suffix = cleanDetailed.removePrefix(cleanPrimary).removePrefix("_")
        if (suffix.isNotEmpty()) suffix else cleanPrimary
    } else {
        if (cleanDetailed.isNotEmpty()) cleanDetailed else "General"
    }

    return remaining.split("_", " ")
        .filter { it.isNotEmpty() }
        .joinToString(" ") { word ->
            word.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
        }
}

@Composable
private fun DashboardDetailCard(
    dashboard: DashboardDetail,
    onDashboardClick: (String) -> Unit,
    dragHandleModifier: Modifier? = null
) {
    val combinedBalance = dashboard.accounts.sumOf {
        val bal = it.currentBalance ?: 0.0
        if (it.type.lowercase() == "credit" || it.type.lowercase() == "loan") -bal else bal
    } + dashboard.realEstateHoldings.sumOf { holding ->
        holding.netValue
    }
    val accountsCount = dashboard.accounts.size
    val membersCount = dashboard.members.size

    Box(modifier = Modifier.padding(horizontal = 16.dp)) {
        GlassCard(
            modifier = Modifier.fillMaxWidth(),
            onClick = {
                if (dragHandleModifier == null) {
                    onDashboardClick(dashboard.dashboardId)
                }
            }
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(
                    modifier = Modifier.weight(1f),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(
                        modifier = Modifier.weight(1f)
                    ) {
                        Text(
                            text = dashboard.name,
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold,
                            color = MaterialTheme.colorScheme.onSurface
                        )
                        if (dashboard.accounts.any { it.loginRequired || it.updateRequired }) {
                            Spacer(modifier = Modifier.height(4.dp))
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(
                                    imageVector = Icons.Default.Warning,
                                    contentDescription = "Warning",
                                    tint = MaterialTheme.colorScheme.error,
                                    modifier = Modifier.size(16.dp)
                                )
                                Spacer(modifier = Modifier.width(4.dp))
                                Text(
                                    text = "One or more of the accounts associated to this dashboard require attention...",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.error
                                )
                            }
                        }
                    }

                    Spacer(modifier = Modifier.width(16.dp))
                    Text(
                        text = "$${combinedBalance.formatAmount()}",
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.primary
                    )
                }

                if (dragHandleModifier != null) {
                    Spacer(modifier = Modifier.width(16.dp))
                    Icon(
                        imageVector = Icons.Default.DragHandle,
                        contentDescription = "Drag to reorder",
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = dragHandleModifier.size(24.dp)
                    )
                } else {
                    Spacer(modifier = Modifier.width(8.dp))
                    Icon(
                        imageVector = Icons.Default.ChevronRight,
                        contentDescription = "View Details",
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = Modifier.size(20.dp)
                    )
                }
            }
        }
    }
}

@Composable
private fun TotalWealthBalanceCard(
    totalBalance: Double,
    lastSync: String? = null,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 12.dp, bottom = 12.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val isNegative = totalBalance < 0
        val absBalance = abs(totalBalance)
        val formattedBalance = absBalance.formatAmount()
        val parts = formattedBalance.split('.')
        val intPart = parts.getOrElse(0) { "0" }
        val decPart = parts.getOrNull(1) ?: "00"

        Text(
            text = "Total Dashboards Balance",
            style = MaterialTheme.typography.labelSmall.copy(letterSpacing = 2.sp),
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            fontWeight = FontWeight.Bold
        )
        Spacer(modifier = Modifier.height(4.dp))
        Row(
            verticalAlignment = Alignment.Bottom
        ) {
            if (isNegative) {
                Text(
                    text = "-",
                    style = MaterialTheme.typography.titleLarge,
                    color = MaterialTheme.colorScheme.error,
                    modifier = Modifier.padding(bottom = 12.dp)
                )
            }
            Text(
                text = "$",
                style = MaterialTheme.typography.titleLarge,
                color = MaterialTheme.colorScheme.primary,
                modifier = Modifier.padding(bottom = 12.dp)
            )
            Text(
                text = intPart,
                style = MaterialTheme.typography.displayLarge.copy(fontSize = 48.sp),
                color = MaterialTheme.colorScheme.onSurface,
                fontWeight = FontWeight.Bold
            )
            Text(
                text = ".$decPart",
                style = MaterialTheme.typography.titleLarge,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(bottom = 8.dp)
            )
        }
        Spacer(modifier = Modifier.height(8.dp))
        Row(
            modifier = Modifier
                .clip(RoundedCornerShape(999.dp))
                .background(MaterialTheme.colorScheme.secondary.copy(alpha = 0.1f))
                .border(
                    1.dp,
                    MaterialTheme.colorScheme.secondary.copy(alpha = 0.2f),
                    RoundedCornerShape(999.dp)
                )
                .padding(horizontal = 12.dp, vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            val formattedSync = lastSync?.let { formatIsoDateTime(it) } ?: "Never"
            Text(
                text = "Last sync: $formattedSync",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.secondary,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
private fun ActiveDashboardsHeader(
    onCreateDashboardClick: () -> Unit,
    onJoinDashboardClick: () -> Unit,
    showConfigAction: Boolean,
    isReordering: Boolean = false,
    onConfigClick: () -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = "Active Dashboards",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface
        )
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            OutlinedButton(
                onClick = onCreateDashboardClick,
                shape = RoundedCornerShape(8.dp),
                colors = ButtonDefaults.outlinedButtonColors(
                    contentColor = MaterialTheme.colorScheme.primary
                ),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary),
                contentPadding = PaddingValues(0.dp),
                modifier = Modifier.size(36.dp)
            ) {
                Icon(
                    imageVector = Icons.Default.Add,
                    contentDescription = "Create",
                )
            }
            OutlinedButton(
                onClick = onJoinDashboardClick,
                shape = RoundedCornerShape(8.dp),
                colors = ButtonDefaults.outlinedButtonColors(
                    contentColor = MaterialTheme.colorScheme.primary
                ),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary),
                contentPadding = PaddingValues(0.dp),
                modifier = Modifier.size(36.dp)
            ) {
                Icon(
                    imageVector = Icons.Outlined.AddLink,
                    contentDescription = "Join",
                )
            }
            if (showConfigAction) {
                OutlinedButton(
                    onClick = onConfigClick,
                    shape = RoundedCornerShape(8.dp),
                    colors = if (isReordering) {
                        ButtonDefaults.outlinedButtonColors(
                            containerColor = MaterialTheme.colorScheme.primary,
                            contentColor = MaterialTheme.colorScheme.onPrimary
                        )
                    } else {
                        ButtonDefaults.outlinedButtonColors(
                            contentColor = MaterialTheme.colorScheme.primary
                        )
                    },
                    border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary),
                    contentPadding = PaddingValues(0.dp),
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = if (isReordering) Icons.Default.Check else Icons.Default.Settings,
                        contentDescription = if (isReordering) "Finish Reordering Dashboards" else "Configure Order",
                    )
                }
            }
        }
    }
}

data class PieSegment(
    val category: String,
    val amount: Double,
    val color: Color
)

@Composable
fun SegmentedControl(
    selectedRange: SpendingRange,
    onRangeSelected: (SpendingRange) -> Unit,
    modifier: Modifier = Modifier
) {
    val options = SpendingRange.entries.toTypedArray()
    Row(
        modifier = modifier
            .horizontalScroll(rememberScrollState())
            .clip(RoundedCornerShape(8.dp))
            .background(Color(0x15FFFFFF))
            .padding(2.dp),
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        options.forEach { option ->
            val isSelected = option == selectedRange
            val backgroundColor by animateColorAsState(
                targetValue = if (isSelected) MaterialTheme.colorScheme.primary else Color.Transparent,
                label = "bgColor"
            )
            val contentColor by animateColorAsState(
                targetValue = if (isSelected) Color(0xFF003731) else MaterialTheme.colorScheme.onSurfaceVariant,
                label = "contentColor"
            )

            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(6.dp))
                    .background(backgroundColor)
                    .clickable { onRangeSelected(option) }
                    .padding(horizontal = 12.dp, vertical = 6.dp),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = option.displayName,
                    style = MaterialTheme.typography.labelSmall,
                    fontWeight = FontWeight.Bold,
                    color = contentColor
                )
            }
        }
    }
}

@OptIn(ExperimentalFlexBoxApi::class)
@Composable
fun RecentSpendingSection(
    modifier: Modifier = Modifier,
    state: DashboardsScreenState.Loaded,
    onRangeSelected: (SpendingRange) -> Unit,
    onViewRecentSpendingClick: () -> Unit
) {
    val selectedRange = state.selectedRange
    val transactions = state.transactions

    val subtitleText = when (selectedRange) {
        SpendingRange.SevenDays -> "Last 7 days from all dashboard linked accounts"
        SpendingRange.OneMonth -> "Last 30 days from all dashboard linked accounts"
        SpendingRange.ThreeMonths -> "Last 90 days from all linked dashboard accounts"
        SpendingRange.SixMonths -> "Last 180 days from all linked dashboard accounts"
        SpendingRange.OneYear -> "Last 365 days from all linked dashboard accounts"
        SpendingRange.YearToDate -> "Year to date from all linked dashboard accounts"
    }

    Column(
        modifier = modifier,
    ) {
        Text(
            text = "Recent Spending",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(4.dp))
        Text(
            text = subtitleText,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(12.dp))

        Box(modifier = Modifier.padding(horizontal = 16.dp)) {
            GlassCard(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = 16.dp)
            ) {
                Column {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SegmentedControl(
                            selectedRange = selectedRange,
                            onRangeSelected = onRangeSelected
                        )
                    }

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        val (totalRecentSpend, segments) = remember(transactions, selectedRange) {
                            calculateRecentSpending(transactions, selectedRange)
                        }

                        AnimatedContent(
                            targetState = selectedRange,
                            transitionSpec = {
                                fadeIn(animationSpec = tween(220, delayMillis = 90)) togetherWith
                                        fadeOut(animationSpec = tween(90))
                            },
                            label = "spendingContentAnimation"
                        ) { _ ->
                            if (totalRecentSpend == 0.0) {
                                val emptyMessage = when (selectedRange) {
                                    SpendingRange.SevenDays -> "No spending transactions recorded in the last 7 days."
                                    SpendingRange.OneMonth -> "No spending transactions recorded in the last month."
                                    SpendingRange.ThreeMonths -> "No spending transactions recorded in the last 3 months."
                                    SpendingRange.SixMonths -> "No spending transactions recorded in the last 6 months."
                                    SpendingRange.OneYear -> "No spending transactions recorded in the last year."
                                    SpendingRange.YearToDate -> "No spending transactions recorded year to date."
                                }
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(24.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Text(
                                        text = emptyMessage,
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant
                                    )
                                }
                            } else {
                                Column(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    RecentSpendingContent(
                                        modifier = Modifier.fillMaxWidth(),
                                        segments = segments,
                                        totalRecentSpend = totalRecentSpend,
                                    )

                                    Spacer(modifier = Modifier.height(24.dp))

                                    Button(
                                        onClick = onViewRecentSpendingClick,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .widthIn(max = 560.dp),
                                        colors = ButtonDefaults.buttonColors(
                                            containerColor = MaterialTheme.colorScheme.primary,
                                            contentColor = Color(0xFF003731)
                                        ),
                                        shape = RoundedCornerShape(8.dp)
                                    ) {
                                        Text(
                                            text = "View Recent Spending",
                                            fontWeight = FontWeight.Bold,
                                            style = MaterialTheme.typography.bodyMedium
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun calculateRecentSpending(
    transactions: List<Transaction>,
    selectedRange: SpendingRange
): Pair<Double, List<PieSegment>> {
    val rangeDateString = try {
        val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
        when (selectedRange) {
            SpendingRange.SevenDays -> today.minus(7, DateTimeUnit.DAY).toString()
            SpendingRange.OneMonth -> today.minus(1, DateTimeUnit.MONTH).toString()
            SpendingRange.ThreeMonths -> today.minus(3, DateTimeUnit.MONTH).toString()
            SpendingRange.SixMonths -> today.minus(6, DateTimeUnit.MONTH).toString()
            SpendingRange.OneYear -> today.minus(1, DateTimeUnit.YEAR).toString()
            SpendingRange.YearToDate -> LocalDate(today.year, 1, 1).toString()
        }
    } catch (e: Exception) {
        ""
    }

    val eligibleTransactions = transactions.filter { transaction ->
        !transaction.isExcludedFromSpending() &&
                transaction.date >= rangeDateString
    }

    val totalRecentSpend = eligibleTransactions.sumOf { kotlin.math.abs(it.amount) }

    val categoryTotals = eligibleTransactions
        .groupBy { transaction ->
            val cat = transaction.category.firstOrNull() ?: "Uncategorized"
            cat.replace("_", " ").lowercase().split(" ").joinToString(" ") { word ->
                word.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
            }
        }
        .mapValues { entry -> entry.value.sumOf { kotlin.math.abs(it.amount) } }

    val sortedCategories = categoryTotals.entries.sortedByDescending { it.value }

    val categoryColors = listOf(
        Color(0xFF2196F3), // Blue
        Color(0xFFFF9800), // Orange
        Color(0xFFE91E63), // Pink
        Color(0xFF9C27B0), // Purple
        Color(0xFF00BCD4), // Cyan
        Color(0xFF4CAF50), // Green
    )

    val tempSegments = mutableListOf<PieSegment>()
    var otherSum = 0.0

    sortedCategories.forEachIndexed { index, entry ->
        if (index < 5) {
            tempSegments.add(
                PieSegment(
                    category = entry.key,
                    amount = entry.value,
                    color = categoryColors[index % categoryColors.size]
                )
            )
        } else {
            otherSum += entry.value
        }
    }

    if (otherSum > 0.0) {
        tempSegments.add(
            PieSegment(
                category = "Other",
                amount = otherSum,
                color = Color(0xFF6B7280) // Gray
            )
        )
    }

    return totalRecentSpend to tempSegments
}

@OptIn(ExperimentalFlexBoxApi::class)
@Composable
private fun RecentSpendingContent(
    modifier: Modifier = Modifier,
    segments: List<PieSegment>,
    totalRecentSpend: Double,
) {
    FlexBox(
        modifier = modifier.fillMaxWidth(),
        config = {
            wrap(FlexWrap.Wrap)
            gap(24.dp)
            alignItems(FlexAlignItems.Center)
        }
    ) {
        Row(
            modifier = Modifier.flex { grow(1.0f) },
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            DonutChart(
                segments = segments,
                totalAmount = totalRecentSpend,
                modifier = Modifier
                    .size(200.dp)
                    .padding(16.dp)
            )
        }

        Column(
            modifier = Modifier
                .flex { grow(1.0f) }
                .widthIn(min = 200.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            segments.forEach { segment ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        modifier = Modifier.weight(1f)
                    ) {
                        Box(
                            modifier = Modifier
                                .size(12.dp)
                                .background(segment.color, CircleShape)
                        )
                        Text(
                            text = segment.category,
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurface,
                            fontWeight = FontWeight.Medium,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    Spacer(modifier = Modifier.width(12.dp))
                    Text(
                        text = "$${segment.amount.formatAmount()}",
                        style = MaterialTheme.typography.bodyMedium,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        }
    }
}

@Composable
fun DonutChart(
    segments: List<PieSegment>,
    totalAmount: Double,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Canvas(modifier = Modifier.fillMaxSize()) {
            val gapAngle = if (segments.size > 1) 1.5f else 0f
            var startAngle = -90f
            segments.forEach { segment ->
                val sweepAngle = ((segment.amount / totalAmount) * 360f).toFloat()
                val adjustedSweep = maxOf(0f, sweepAngle - gapAngle)
                drawArc(
                    color = segment.color,
                    startAngle = startAngle + gapAngle / 2f,
                    sweepAngle = adjustedSweep,
                    useCenter = false,
                    style = Stroke(
                        width = 24.dp.toPx(),
                        cap = StrokeCap.Butt
                    )
                )
                startAngle += sweepAngle
            }
        }

        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "Total Spent",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Spacer(modifier = Modifier.height(2.dp))
            Text(
                text = "$${totalAmount.formatAmount()}",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.onSurface
            )
        }
    }
}

@Composable
fun RecurringSubscriptionsSection(
    modifier: Modifier = Modifier,
    state: DashboardsScreenState.Loaded,
    onViewRecurringTransactionsClick: () -> Unit
) {
    val recurringOutflows = remember(state.recurringTransactions) {
        state.recurringTransactions.filter { it.streamType == "outflow" && it.isActive }
    }

    val accountNames = remember(state.dashboards) {
        state.dashboards.flatMap { it.accounts }
            .associate { account ->
                val fullName = if (!account.institutionName.isNullOrBlank()) {
                    "${account.displayName} • ${account.institutionName}"
                } else {
                    account.displayName
                }
                account.accountId to fullName
            }
    }

    Column(
        modifier = modifier
    ) {
        Text(
            text = "Recurring Subscriptions",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(4.dp))
        Text(
            text = "Active bills and subscriptions from all dashboard accounts",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(12.dp))

        Box(modifier = Modifier.padding(horizontal = 16.dp)) {
            GlassCard(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = 16.dp)
            ) {
                Column {
                    if (recurringOutflows.isEmpty()) {
                        Text(
                            text = "No recurring subscriptions identified.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.padding(vertical = 12.dp)
                        )
                    } else {
                        recurringOutflows.take(4).forEach { stream ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(vertical = 8.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(
                                        text = if (stream.merchantName.isNullOrBlank()) stream.description else stream.merchantName,
                                        style = MaterialTheme.typography.bodyLarge,
                                        fontWeight = FontWeight.Bold,
                                        color = MaterialTheme.colorScheme.onSurface,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    Spacer(modifier = Modifier.height(2.dp))
                                    val accountName = accountNames[stream.accountId] ?: "Unknown Account"
                                    Text(
                                        text = "${stream.frequency.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }} • $accountName",
                                        style = MaterialTheme.typography.labelSmall,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                                Spacer(modifier = Modifier.width(12.dp))
                                Text(
                                    text = "$${stream.averageAmount.amount.formatAmount()}",
                                    style = MaterialTheme.typography.bodyMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                            }
                        }
                    }

                    Spacer(modifier = Modifier.height(16.dp))

                    Button(
                        onClick = onViewRecurringTransactionsClick,
                        modifier = Modifier.fillMaxWidth(),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = MaterialTheme.colorScheme.primary,
                            contentColor = Color(0xFF003731)
                        ),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Text(
                            text = "View All Subscriptions",
                            fontWeight = FontWeight.Bold,
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun TrendingSpendingSection(
    state: DashboardsScreenState.Loaded,
    isCumulative: Boolean,
    onCumulativeChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier
) {
    val today = remember { Clock.System.todayIn(TimeZone.currentSystemDefault()) }
    val trendingData = remember(state.transactions, today, isCumulative) {
        calculateTrendingSpendingData(state.transactions, today, isCumulative)
    }

    Column(modifier = modifier) {
        Text(
            text = "Trending Spending",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(4.dp))
        Text(
            text = "Compare daily spending of this month with last month",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(12.dp))

        Box(modifier = Modifier.padding(horizontal = 16.dp)) {
            GlassCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Row(
                            modifier = Modifier
                                .clip(RoundedCornerShape(8.dp))
                                .background(Color(0x15FFFFFF))
                                .padding(2.dp),
                            horizontalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            val options = listOf(true to "Cumulative", false to "Daily")
                            options.forEach { (optionVal, label) ->
                                val isSelected = isCumulative == optionVal
                                val bg by animateColorAsState(
                                    targetValue = if (isSelected) MaterialTheme.colorScheme.primary else Color.Transparent,
                                    label = "tabBg"
                                )
                                val textCol by animateColorAsState(
                                    targetValue = if (isSelected) Color(0xFF003731) else MaterialTheme.colorScheme.onSurfaceVariant,
                                    label = "tabText"
                                )
                                Box(
                                    modifier = Modifier
                                        .clip(RoundedCornerShape(6.dp))
                                        .background(bg)
                                        .clickable { onCumulativeChange(optionVal) }
                                        .padding(horizontal = 10.dp, vertical = 4.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Text(
                                        text = label,
                                        style = MaterialTheme.typography.labelSmall,
                                        fontWeight = FontWeight.Bold,
                                        color = textCol
                                    )
                                }
                            }
                        }
                    }

                    Spacer(modifier = Modifier.height(24.dp))

                    val primaryColor = MaterialTheme.colorScheme.primary
                    val secondaryColor = Color(0xFF8B5CF6)
                    val gridColor = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f)
                    val labelColor = MaterialTheme.colorScheme.onSurfaceVariant

                    TrendingLineGraph(
                        currentPlotPoints = trendingData.currentPlotPoints,
                        prevPlotPoints = trendingData.prevPlotPoints,
                        maxVal = trendingData.maxVal,
                        primaryColor = primaryColor,
                        secondaryColor = secondaryColor,
                        gridColor = gridColor,
                        labelColor = labelColor,
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(200.dp)
                    )

                    Spacer(modifier = Modifier.height(20.dp))

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.weight(1f)
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(10.dp)
                                    .background(primaryColor, CircleShape)
                            )
                            Spacer(modifier = Modifier.width(8.dp))
                            Column {
                                Text(
                                    text = "${trendingData.currentMonthName} (This Month)",
                                    style = MaterialTheme.typography.labelSmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                                Text(
                                    text = "$${trendingData.totalCurrent.formatAmount()}",
                                    style = MaterialTheme.typography.titleMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = MaterialTheme.colorScheme.onSurface
                                )
                            }
                        }

                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.weight(1f)
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(10.dp)
                                    .background(secondaryColor, CircleShape)
                            )
                            Spacer(modifier = Modifier.width(8.dp))
                            Column {
                                Text(
                                    text = "${trendingData.previousMonthName} (Last Month)",
                                    style = MaterialTheme.typography.labelSmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                                Text(
                                    text = "$${trendingData.totalPrev.formatAmount()}",
                                    style = MaterialTheme.typography.titleMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = MaterialTheme.colorScheme.onSurface
                                )
                            }
                        }
                    }

                    val diff = trendingData.totalCurrent - trendingData.totalPrev
                    Spacer(modifier = Modifier.height(16.dp))
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clip(RoundedCornerShape(8.dp))
                            .background(if (trendingData.isPacingPositive) MaterialTheme.colorScheme.error.copy(alpha = 0.05f) else MaterialTheme.colorScheme.primary.copy(alpha = 0.05f))
                            .border(1.dp, if (trendingData.isPacingPositive) MaterialTheme.colorScheme.error.copy(alpha = 0.1f) else MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), RoundedCornerShape(8.dp))
                            .padding(12.dp)
                    ) {
                        Text(
                            text = trendingData.pacingText,
                            style = MaterialTheme.typography.bodySmall,
                            color = if (trendingData.isPacingPositive) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.primary
                        )
                    }

                    Spacer(modifier = Modifier.height(12.dp))
                    Text(
                        text = "* Spending does not include credit card payments, loan disbursements, or transfers in/out of accounts.",
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        }
    }
}

@Composable
private fun TrendingLineGraph(
    currentPlotPoints: List<Double>,
    prevPlotPoints: List<Double>,
    maxVal: Double,
    primaryColor: Color,
    secondaryColor: Color,
    gridColor: Color,
    labelColor: Color,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(180.dp)
        ) {
            Canvas(modifier = Modifier.fillMaxSize()) {
                val width = size.width
                val height = size.height
                
                val paddingLeft = 0f
                val paddingRight = 0f
                val paddingTop = 10.dp.toPx()
                val paddingBottom = 20.dp.toPx()
                
                val graphWidth = width - paddingLeft - paddingRight
                val graphHeight = height - paddingTop - paddingBottom
                
                val gridLines = 4
                for (i in 0..gridLines) {
                    val y = paddingTop + graphHeight * (1f - i.toFloat() / gridLines)
                    drawLine(
                        color = gridColor,
                        start = Offset(paddingLeft, y),
                        end = Offset(width, y),
                        strokeWidth = 1.dp.toPx()
                    )
                }
                
                val maxDays = 30f
                
                if (prevPlotPoints.isNotEmpty()) {
                    val prevPath = Path()
                    prevPlotPoints.forEachIndexed { index, valAmt ->
                        val x = paddingLeft + (index.toFloat() / maxDays) * graphWidth
                        val y = paddingTop + graphHeight * (1f - (valAmt.toFloat() / maxVal.toFloat()))
                        if (index == 0) {
                            prevPath.moveTo(x, y)
                        } else {
                            prevPath.lineTo(x, y)
                        }
                    }
                    drawPath(
                        path = prevPath,
                        color = secondaryColor.copy(alpha = 0.5f),
                        style = Stroke(
                            width = 2.dp.toPx(),
                            pathEffect = PathEffect.dashPathEffect(
                                floatArrayOf(10f, 10f), 0f
                            )
                        )
                    )
                }
                
                if (currentPlotPoints.isNotEmpty()) {
                    val currentPath = Path()
                    val fillPath = Path()
                    
                    currentPlotPoints.forEachIndexed { index, valAmt ->
                        val x = paddingLeft + (index.toFloat() / maxDays) * graphWidth
                        val y = paddingTop + graphHeight * (1f - (valAmt.toFloat() / maxVal.toFloat()))
                        if (index == 0) {
                            currentPath.moveTo(x, y)
                            fillPath.moveTo(x, paddingTop + graphHeight)
                            fillPath.lineTo(x, y)
                        } else {
                            currentPath.lineTo(x, y)
                            fillPath.lineTo(x, y)
                        }
                        
                        if (index == currentPlotPoints.lastIndex) {
                            fillPath.lineTo(x, paddingTop + graphHeight)
                        }
                    }
                    
                    if (currentPlotPoints.size > 1) {
                        drawPath(
                            path = fillPath,
                            brush = Brush.verticalGradient(
                                colors = listOf(
                                    primaryColor.copy(alpha = 0.15f),
                                    Color.Transparent
                                )
                            )
                        )
                    }
                    
                    drawPath(
                        path = currentPath,
                        color = primaryColor,
                        style = Stroke(
                            width = 3.dp.toPx(),
                            cap = StrokeCap.Round
                        )
                    )
                    
                    val lastIndex = currentPlotPoints.lastIndex
                    val lastVal = currentPlotPoints.last()
                    val lastX = paddingLeft + (lastIndex.toFloat() / maxDays) * graphWidth
                    val lastY = paddingTop + graphHeight * (1f - (lastVal.toFloat() / maxVal.toFloat()))
                    
                    drawCircle(
                        color = primaryColor.copy(alpha = 0.2f),
                        radius = 8.dp.toPx(),
                        center = Offset(lastX, lastY)
                    )
                    drawCircle(
                        color = primaryColor,
                        radius = 4.dp.toPx(),
                        center = Offset(lastX, lastY)
                    )
                }
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 4.dp),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text("Day 1", style = MaterialTheme.typography.labelSmall, color = labelColor)
            Text("Day 10", style = MaterialTheme.typography.labelSmall, color = labelColor)
            Text("Day 20", style = MaterialTheme.typography.labelSmall, color = labelColor)
            Text("Day 30", style = MaterialTheme.typography.labelSmall, color = labelColor)
        }
    }
}

private data class TrendingSpendingData(
    val currentMonthName: String,
    val previousMonthName: String,
    val currentPlotPoints: List<Double>,
    val prevPlotPoints: List<Double>,
    val maxVal: Double,
    val totalCurrent: Double,
    val totalPrev: Double,
    val pacingText: String,
    val isPacingPositive: Boolean
)

private fun calculateTrendingSpendingData(
    transactions: List<Transaction>,
    today: LocalDate,
    isCumulative: Boolean
): TrendingSpendingData {
    val currentYear = today.year
    val currentMonth = today.month.number
    
    val previousMonthDate = today.minus(1, DateTimeUnit.MONTH)
    val prevYear = previousMonthDate.year
    val prevMonth = previousMonthDate.month.number

    val daysInCurrentMonth = getDaysInMonth(currentMonth, currentYear)
    val daysInPrevMonth = getDaysInMonth(prevMonth, prevYear)

    val currentMonthDaily = MutableList(daysInCurrentMonth) { 0.0 }
    val previousMonthDaily = MutableList(daysInPrevMonth) { 0.0 }

    transactions.forEach { tx ->
        if (tx.amount > 0 && !tx.isExcludedFromSpending()) {
            try {
                val date = LocalDate.parse(tx.date)
                if (date.year == currentYear && date.month.number == currentMonth) {
                    val dayIndex = date.day - 1
                    if (dayIndex in 0 until daysInCurrentMonth) {
                        currentMonthDaily[dayIndex] += tx.amount
                    }
                } else if (date.year == prevYear && date.month.number == prevMonth) {
                    val dayIndex = date.day - 1
                    if (dayIndex in 0 until daysInPrevMonth) {
                        previousMonthDaily[dayIndex] += tx.amount
                    }
                }
            } catch (e: Exception) {}
        }
    }

    val currentMonthPlot = if (isCumulative) {
        var runningSum = 0.0
        currentMonthDaily.map {
            runningSum += it
            runningSum
        }
    } else {
        currentMonthDaily
    }

    val previousMonthPlot = if (isCumulative) {
        var runningSum = 0.0
        previousMonthDaily.map {
            runningSum += it
            runningSum
        }
    } else {
        previousMonthDaily
    }

    val currentPlotPoints = currentMonthPlot.take(today.day)

    val maxVal = maxOf(
        currentPlotPoints.maxOrNull() ?: 0.0,
        previousMonthPlot.maxOrNull() ?: 0.0,
        10.0
    )

    val currentMonthName = today.month.name.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
    val previousMonthName = previousMonthDate.month.name.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }

    val totalCurrent = currentMonthDaily.sum()
    val totalPrev = previousMonthDaily.sum()
    val totalPrevUpToSameDay = previousMonthDaily.take(today.day).sum()

    val diff = totalCurrent - totalPrevUpToSameDay
    val percent = if (totalPrevUpToSameDay > 0) (abs(diff) / totalPrevUpToSameDay) * 100 else 0.0
    val pacingText = if (diff > 0) {
        "Spending is up ${percent.formatAmount()}% compared to the same point last month ($previousMonthName ${today.day}: $${totalPrevUpToSameDay.formatAmount()})."
    } else if (diff < 0) {
        "Spending is down ${percent.formatAmount()}% compared to the same point last month ($previousMonthName ${today.day}: $${totalPrevUpToSameDay.formatAmount()})."
    } else {
        "Spending is exactly pacing with last month at this point."
    }

    return TrendingSpendingData(
        currentMonthName = currentMonthName,
        previousMonthName = previousMonthName,
        currentPlotPoints = currentPlotPoints,
        prevPlotPoints = previousMonthPlot,
        maxVal = maxVal,
        totalCurrent = totalCurrent,
        totalPrev = totalPrev,
        pacingText = pacingText,
        isPacingPositive = diff > 0
    )
}

private fun <T> List<T>.reordered(fromKey: Any, toKey: Any, getId: (T) -> Any): List<T>? {
    val fromIndex = indexOfFirst { getId(it) == fromKey }
    val toIndex = indexOfFirst { getId(it) == toKey }
    if (fromIndex == -1 || toIndex == -1) return null
    return toMutableList().apply {
        add(toIndex, removeAt(fromIndex))
    }
}

private fun <T> List<T>.reordered(fromIndex: Int, toIndex: Int, getId: (T) -> Any): List<T>? {
    if (fromIndex == -1 || toIndex == -1) return null
    return toMutableList().apply {
        add(toIndex, removeAt(fromIndex))
    }
}

private fun getDaysInMonth(month: Int, year: Int): Int {
    return when (month) {
        2 -> if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }
}
 
@OptIn(ExperimentalComposeUiApi::class)
fun Modifier.mouseWheelHorizontalScroll(scrollState: ScrollState): Modifier = this.pointerInput(scrollState) {
    awaitPointerEventScope {
        while (true) {
            val event = awaitPointerEvent()
            if (event.type == PointerEventType.Scroll) {
                val change = event.changes.firstOrNull()
                if (change != null) {
                    val scrollDelta = change.scrollDelta
                    val delta = if (scrollDelta.x != 0f) scrollDelta.x else scrollDelta.y
                    if (delta != 0f) {
                        scrollState.dispatchRawDelta(delta * 40f)
                        change.consume()
                    }
                }
            }
        }
    }
}

fun Modifier.mouseDragHorizontalScroll(scrollState: ScrollState): Modifier = this.pointerInput(scrollState) {
    detectDragGestures { change, dragAmount ->
        change.consume()
        scrollState.dispatchRawDelta(-dragAmount.x)
    }
}

@Composable
fun IncomeVsExpensesSection(
    state: DashboardsScreenState.Loaded,
    modifier: Modifier = Modifier,
    onViewDetailsClick: () -> Unit = {}
) {
    val data = state.incomeVsExpenses

    Column(modifier = modifier) {
        Text(
            text = "Income vs Expenses",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(4.dp))
        Text(
            text = "Summary of all non-investment accounts",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.padding(horizontal = 16.dp)
        )
        Spacer(modifier = Modifier.height(12.dp))

        Box(modifier = Modifier.padding(horizontal = 16.dp)) {
            GlassCard(modifier = Modifier.fillMaxWidth()) {
                Column(
                    verticalArrangement = Arrangement.spacedBy(24.dp)
                ) {
                    val scrollState = rememberScrollState()
                    LaunchedEffect(data.size, scrollState.maxValue) {
                        scrollState.scrollTo(scrollState.maxValue)
                    }

                    val columnWidth = 104.dp
                    val totalWidth = columnWidth * data.size.coerceAtLeast(1)

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .mouseWheelHorizontalScroll(scrollState)
                            .mouseDragHorizontalScroll(scrollState)
                            .horizontalScroll(scrollState)
                    ) {
                        Column(
                            modifier = Modifier.width(totalWidth),
                            verticalArrangement = Arrangement.spacedBy(16.dp)
                        ) {
                            // Chart Canvas
                            IncomeVsExpensesChart(
                                data = data,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(200.dp)
                            )

                            // Month Labels & Net Income summary below chart
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceAround
                            ) {
                                data.forEach { item ->
                                    Column(
                                        modifier = Modifier
                                            .width(columnWidth)
                                            .padding(horizontal = 2.dp),
                                        horizontalAlignment = Alignment.CenterHorizontally
                                    ) {
                                        Text(
                                            text = item.monthName,
                                            style = MaterialTheme.typography.labelMedium,
                                            fontWeight = FontWeight.Bold,
                                            color = MaterialTheme.colorScheme.onSurface,
                                            maxLines = 1
                                        )
                                        val netSign = if (item.netIncome >= 0) "+" else "-"
                                        Text(
                                            text = "$netSign$${kotlin.math.abs(item.netIncome).formatAmount()}",
                                            style = MaterialTheme.typography.labelSmall,
                                            color = if (item.netIncome >= 0) Color(0xFF4CAF50) else Color(0xFFEF5350),
                                            maxLines = 1
                                        )
                                    }
                                }
                            }
                        }
                    }

                    // Legend Row (Moved to bottom)
                    IncomeVsExpensesLegend()

                    Button(
                        onClick = onViewDetailsClick,
                        modifier = Modifier.fillMaxWidth(),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = MaterialTheme.colorScheme.primary,
                            contentColor = Color(0xFF003731)
                        ),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Text(
                            text = "View Details",
                            fontWeight = FontWeight.Bold,
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                }
            }
        }
    }
}

@PreviewLightDark
@PreviewScreenSizes
@Composable
fun DashboardsScreenPreview(
    @PreviewParameter(DashboardsPreviewParameterProvider::class) state: DashboardsScreenState
) {
    AppTheme(
        darkTheme = isSystemInDarkTheme(),
        dynamicColor = false,
    ) {
        Surface {
            DashboardsScreenContent(
                state = state,
                onDashboardClick = {},
                onCreateDashboardClick = {},
                onJoinDashboardClick = {},
                onViewRecentSpendingClick = {},
                onViewRecurringTransactionsClick = {},
                onCreateBudgetClick = {},
                onBudgetClick = {},
                onManageAccounts = {},
                onRangeSelected = {}
            )
        }
    }
}